// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__30tIH","row":"Node_row__9POnA","label":"Node_label__1DvUU","footer":"Node_footer__3PLxN"};